import { render } from "./DigiConf.vue?vue&type=template&id=238cd92c&scoped=true"
import script from "./DigiConf.vue?vue&type=script&lang=js"
export * from "./DigiConf.vue?vue&type=script&lang=js"

import "./DigiConf.vue?vue&type=style&index=0&id=238cd92c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-238cd92c"

export default script